import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { TestimonialCard } from "@/components/ui/testimonial-card";
import { useMediaQuery } from "@/hooks/use-media-query";
interface Testimonial {
  id: number;
  quote: string;
  author: string;
  role?: string;
  imageUrl?: string;
  rating?: number;
  datePublished: string;
}
interface TestimonialCarouselProps {
  testimonials: Testimonial[];
}
export default function TestimonialCarousel({
  testimonials
}: TestimonialCarouselProps) {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  return <div className="relative mx-auto max-w-6xl">
      <Carousel opts={{
      align: "start",
      loop: true
    }} className="w-full">
        <CarouselContent className="-ml-4">
          {testimonials.map(testimonial => <CarouselItem key={testimonial.id} className={`pl-4 ${isDesktop ? 'md:basis-1/2' : 'basis-full'}`}>
              <div className="p-1 h-full">
                <TestimonialCard quote={testimonial.quote} author={testimonial.author} role={testimonial.role} imageUrl={testimonial.imageUrl} rating={testimonial.rating} className="h-full flex flex-col" />
              </div>
            </CarouselItem>)}
        </CarouselContent>
        <CarouselPrevious className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 hidden md:flex border-2 border-grandpal-green-dark text-grandpal-green-dark hover:bg-grandpal-green-dark hover:text-white" />
        <CarouselNext className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 hidden md:flex border-2 border-grandpal-green-dark text-grandpal-green-dark hover:bg-grandpal-green-dark hover:text-white" />
      </Carousel>
      
      <div className="flex justify-center gap-2 mt-8">
        {testimonials.map((_, index) => <div key={index} className="w-2 h-2 rounded-full opacity-50 bg-slate-50" />)}
      </div>
    </div>;
}